// Wave-3 §3: shared Recharts chrome constants. Dotted `strokeDasharray="3 3"` grids
// become solid faint lines; timelines get a uniform minimum gap between x-ticks so
// short-form dates never collide at dense (4-8 panel) layouts.
export const GRID_STROKE = 'rgba(0, 0, 0, 0.08)'
export const X_TICK_MIN_GAP = 24

// Wave-4 §5 (FU-50 surface 2): emphasized zero line for charts with negative domain.
export const ZERO_LINE_STROKE = 'rgba(0,0,0,0.55)'

// Wave-4 §2 (D3): reserved status pair for signed growth chips — distinct from the
// categorical palette (which deliberately has NO red, tenantPalette.ts) and from any
// tenant brand. Both ≥ 4.5:1 on white. NEVER color-alone: ▲/▼ always accompanies.
export const GROWTH_UP = '#1b7f3b'
export const GROWTH_DOWN = '#b3261e'

/** Wave-4 §2 (D3, scoped-tabular): axis ticks are COLUMNS of numbers — tabular keeps
 *  them steady under live repaint. Thread as `tick={AXIS_TICK}`. */
export const AXIS_TICK_STYLE = { fontVariantNumeric: 'tabular-nums' } as const
/** Hoisted tick prop — `tick={{ style: AXIS_TICK_STYLE }}` allocated a fresh object per
 *  render per axis across ~8 chart files (fable Minor 7e). Thread as `tick={AXIS_TICK}`. */
export const AXIS_TICK = { style: AXIS_TICK_STYLE } as const
/** Same rule for tooltip value columns (Recharts contentStyle). */
export const TOOLTIP_NUM_STYLE = { fontVariantNumeric: 'tabular-nums' } as const

/** Wave-5 §3: neutral fill for SVG growth labels. GrowthChip rides the `text.secondary`
 *  theme token; raw SVG <text> can't — this is MUI's light-mode text.secondary value. */
export const GROWTH_NEUTRAL = 'rgba(0, 0, 0, 0.6)'
